export const GET_INCIDENTS_MAP_LOAD = 'GET_INCIDENTS_MAP_LOAD';
export const GET_INCIDENTS_MAP_SUCCESS = 'GET_INCIDENTS_MAP_SUCCESS';
export const GET_INCIDENTS_MAP_ERROR = 'GET_INCIDENTS_MAP_ERROR';

export const CHANGE_FILTER = 'CHANGE_FILTER';
export const FILTER_CHANGED = 'FILTER_CHANGED';
